// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {collection, getDocs, getFirestore} from "firebase/firestore/lite"
import { browserSessionPersistence, getAuth, onAuthStateChanged, setPersistence } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcVb6xRPBtnE9YBIES-TnALUSo1Ks_68o",
  authDomain: "shopsyi-team.firebaseapp.com",
  projectId: "shopsyi-team",
  storageBucket: "shopsyi-team.appspot.com",
  messagingSenderId: "319843231084",
  appId: "1:319843231084:web:49eda7cc6e0f412f737f49",
  measurementId: "G-D2YM14HDMT"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
/* const analytics = getAnalytics(app); */


export const auth = getAuth(app);

//Firestore data fetch
export const userData = collection(db,"users")
export const prodList = collection(db, "products")
export const reqList  = collection(db,"listing-requests")

async function fetchFirestore() {

  const data = await getDocs(userData);
  const result = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
  console.log(result)

  return 0;

}
fetchFirestore()

setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log("Auth persistence set to 'local'");
  })
  .catch((error) => {
    console.log("Error setting auth persistence: ", error);
  });


  //Get currrent userID
  let userId;

// Listen for changes in the user authentication state
onAuthStateChanged(auth, (user) => {
  if (user) {
    userId = user.uid;
    console.log(`User with ID ${userId} is signed in`);
  } else {
    userId = null;
    console.log(`No user is signed in`);
  }
});
  
export {userId};
  
  
  
  
  